import { TRACKING_EVENT_NAMES } from '../../hooks/analytics_events/constants'

export const trackSendViaCalendlyEvent = ({ track, contactUuid, step }) => {
  track({
    name: TRACKING_EVENT_NAMES.SEND_VIA_CALENDLY,
    properties: {
      contact_uuid: contactUuid,
      contact_source: null,
      step
    }
  })
}
